"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.claimEmailParser = claimEmailParser;
exports.defaultOptionals = exports.createResource = void 0;
exports.historyFormatter = historyFormatter;
exports.metadataFormatter = exports.messageFormatter = void 0;
exports.planFormatter = planFormatter;
exports.priceAlertFormatter = priceAlertFormatter;
exports.withPhoneNumberToken = exports.withOptionals = exports.withExtraAuth = exports.withEmailCodeToken = exports.withCaptcha = exports.withAuth = exports.scheduledBreakTransformer = void 0;
exports.withSignUpBody = withSignUpBody;
exports.withSuperSession = exports.withSignUpHeaders = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _toPairs = _interopRequireDefault(require("lodash/toPairs"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _functools = require("@edison/functools");
var _requests = require("@edison/requests");
var _constants = require("../utils/constants");
var _excluded = ["extendInfo"],
  _excluded2 = ["sift", "pricealert"],
  _excluded3 = ["domain", "email_time"],
  _excluded4 = ["domain"],
  _excluded5 = ["messages"],
  _excluded6 = ["planId"],
  _excluded7 = ["days", "startTime", "endTime", "timezone"],
  _excluded8 = ["days", "startTime", "endTime"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var withSignUpHeaders = exports.withSignUpHeaders = function withSignUpHeaders(_ref) {
  var recoveryMethod = _ref.recoveryMethod,
    username = _ref.username,
    password = _ref.password,
    captcha = _ref.captcha,
    castle = _ref.castle;
  var headers = {
    'x-Auth-Captcha': captcha,
    'x-Auth-Password': password,
    'x-Timezone': _momentTimezone["default"].tz.guess()
  };
  if (!(0, _isNil["default"])(username)) {
    headers['x-Auth-User'] = username;
  }
  if (!(0, _isNil["default"])(castle)) {
    headers[_constants.CASTLE_TOKEN_HEADER] = castle;
  }
  var recoveryMethodWrapper = function recoveryMethodWrapper(input) {
    return input;
  };
  if (recoveryMethod.type === _constants.recoveryMethods.sms) {
    recoveryMethodWrapper = withPhoneNumberToken(recoveryMethod.token);
  } else if (recoveryMethod.type === _constants.recoveryMethods.email) {
    recoveryMethodWrapper = withEmailCodeToken(recoveryMethod.token);
  }
  return (0, _functools.compose)((0, _requests.withHeaders)(headers), recoveryMethodWrapper);
};

/**
 * Helper to put extra auth information into request headers
 *
 * @public
 * @param {ExtraAuth} auth
 * @returns {Function}
 */
var withExtraAuth = exports.withExtraAuth = function withExtraAuth(auth) {
  return (0, _requests.withHeaders)({
    Authorization: "Bearer ".concat(auth.token)
  });
};

/**
 * Helper to put auth information into request headers
 *
 * @public
 * @param {Auth} auth
 * @returns {Function}
 */
var withAuth = exports.withAuth = function withAuth(auth) {
  return (0, _requests.withHeaders)({
    Authorization: "Bearer ".concat(auth.token),
    'X-Auth-User': auth.user
  });
};

/**
 * Helper to put the super session Id into request headers
 *
 * @public
 * @param {string?} sessionId
 * @returns {Function}
 */
var withSuperSession = exports.withSuperSession = function withSuperSession(sessionId) {
  return (0, _requests.withHeaders)({
    'X-Super-Session-ID': sessionId
  });
};

/**
 * Helper to add extra parameters in request options
 *
 * @public
 * @param {Object} source - The parameters to process
 * @returns {Function}
 */
var withOptionals = exports.withOptionals = function withOptionals() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (optionals) {
    return (0, _reduce["default"])((0, _toPairs["default"])(source), function (prev, _ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2["default"])({}, key, value));
    }, _objectSpread({}, optionals));
  };
};
var defaultOptionals = exports.defaultOptionals = {
  cache: 'default',
  snakify: false,
  camelize: false,
  momentize: false,
  excludeSnakify: [],
  excludeCamelize: [],
  paramsFormat: {
    snakify: true,
    arrayFormat: 'repeat'
  }
};
/**
 * Thunk function to provide more ability for API request
 * such as abortion and cancellation
 *
 * @public
 * @param {Function} fn - The function to be thunked
 * @param {number} retries - Number of retries, default to 0
 * @param {number} retryDelay - Pause time before the next shot
 * @returns {Resource}
 */
var createResource = exports.createResource = function createResource(fn) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var retryDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  var controller = new AbortController();
  var signal = controller.signal;

  // Delay function to pause the request before next
  var _sleep = function _sleep(delayMs) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, delayMs);
    });
  };
  var _requestWithRetry = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var i,
        response,
        isLastAttempt,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            i = 0;
          case 1:
            if (!(i < retries)) {
              _context.next = 21;
              break;
            }
            _context.prev = 2;
            _context.next = 5;
            return fn.apply(void 0, _args);
          case 5:
            response = _context.sent;
            if (response.ok) {
              _context.next = 8;
              break;
            }
            throw new Error(_constants.INVALID_RESPONSE);
          case 8:
            return _context.abrupt("return", response);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            isLastAttempt = i + 1 === retries;
            if (!isLastAttempt) {
              _context.next = 16;
              break;
            }
            throw _context.t0;
          case 16:
            _context.next = 18;
            return _sleep(retryDelay);
          case 18:
            i++;
            _context.next = 1;
            break;
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function _requestWithRetry() {
      return _ref4.apply(this, arguments);
    };
  }();
  return {
    read: function read() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return retries > 0 ? _requestWithRetry.apply(void 0, args.concat([{
        signal: signal
      }])) : fn.apply(void 0, args.concat([{
        signal: signal
      }]));
    },
    abort: function abort() {
      return controller.abort();
    }
  };
};

/**
 * Transform the structure of metadata list
 *
 * @public
 * @param {Array} messages - The original messages list
 * @returns {Array}
 */
var metadataFormatter = exports.metadataFormatter = function metadataFormatter(messages) {
  return (messages || []).map(function (_ref5) {
    var id = _ref5.id,
      thread_uuid = _ref5.thread_uuid,
      label_uuids = _ref5.label_uuids,
      internal_date = _ref5.internal_date;
    return {
      id: id,
      date: internal_date,
      threadId: thread_uuid,
      labelIds: label_uuids || []
    };
  });
};

/**
 * Value validation and format for message structure
 *
 * @public
 * @param {MessageFromApi} message
 * @returns {Message}
 */
var messageFormatter = exports.messageFormatter = function messageFormatter(message) {
  var _message$extendInfo = message.extendInfo,
    extendInfo = _message$extendInfo === void 0 ? {} : _message$extendInfo,
    restMessage = (0, _objectWithoutProperties2["default"])(message, _excluded);
  var sift = extendInfo.sift,
    pricealert = extendInfo.pricealert,
    restInfo = (0, _objectWithoutProperties2["default"])(extendInfo, _excluded2);
  return _objectSpread(_objectSpread({}, restMessage), {}, {
    extendInfo: _objectSpread(_objectSpread({}, restInfo), {}, {
      sift: (0, _isNil["default"])(sift) ? [] : sift.map(function (_ref6) {
        var domain = _ref6.domain,
          email_time = _ref6.email_time,
          payload = (0, _objectWithoutProperties2["default"])(_ref6, _excluded3);
        return {
          domain: domain,
          payload: _objectSpread(_objectSpread({}, payload), {}, {
            email_time: email_time || restMessage.date
          })
        };
      }),
      priceAlert: (0, _isNil["default"])(pricealert) ? [] : pricealert.map(priceAlertFormatter).filter(Boolean)
    })
  });
};
function priceAlertFormatter(input) {
  var _input = input;
  if (typeof _input === 'string') {
    try {
      _input = JSON.parse(input);
    } catch (e) {
      return null;
    }
  }
  var _input2 = _input,
    domain = _input2.domain,
    payload = (0, _objectWithoutProperties2["default"])(_input2, _excluded4);
  return {
    domain: domain,
    payload: payload
  };
}
function claimEmailParser(input) {
  return input.replace(/\b(?:https?:\/\/)(?:(?:[a-z]+\.)+)[^\s,]+\b/, function (matched) {
    return "<a href=\"".concat(matched, "\" target=\"__blank\">").concat(matched, "</a>");
  }).replace(/\\n|\n|\r/g, '<br/>');
}
function withSignUpBody(recoveryMethod, firstName, lastName, birthday, tnc, optIn) {
  var rest = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var recovery = {};
  if (recoveryMethod.type === _constants.recoveryMethods.sms) {
    recovery['phoneNumber'] = recoveryMethod.value;
  } else if (recoveryMethod.type === _constants.recoveryMethods.email) {
    recovery['email'] = recoveryMethod.value;
  }
  return (0, _requests.withBody)(_objectSpread(_objectSpread({}, rest), {}, {
    tcAccepted: tnc,
    settings: {
      account: {
        recovery: _objectSpread({}, recovery),
        profile: {
          senderName: "".concat(firstName, " ").concat(lastName),
          birthday: birthday
        },
        dataSharing: {
          insightEnabled: optIn
        }
      }
    }
  }));
}
function historyFormatter(histories) {
  var types = new Set([_constants.historyTypes.MESSAGES_ADDED, _constants.historyTypes.MESSAGES_DELETED, _constants.historyTypes.LABELS_ADDED, _constants.historyTypes.LABELS_REMOVED]);
  return histories.map(function (history) {
    return (0, _mapValues["default"])(history, function (item, key) {
      if (types.has(key)) {
        return item.map(function (_ref7) {
          var messages = _ref7.messages,
            rest = (0, _objectWithoutProperties2["default"])(_ref7, _excluded5);
          var id = messages.id,
            threadId = messages.threadId,
            labelIds = messages.labelIds,
            date = messages.date;
          return _objectSpread(_objectSpread({}, rest), {}, {
            messages: {
              id: id,
              date: date,
              threadId: threadId,
              labelIds: labelIds || []
            }
          });
        });
      } else {
        return item;
      }
    });
  }).sort(function (a, b) {
    return a.id < b.id ? -1 : 1;
  });
}
function planFormatter(_ref8) {
  var planId = _ref8.planId,
    rest = (0, _objectWithoutProperties2["default"])(_ref8, _excluded6);
  return _objectSpread(_objectSpread({}, rest), {}, {
    id: planId
  });
}
var scheduledBreakTransformer = exports.scheduledBreakTransformer = {
  toAPI: function toAPI(scheduledBreak) {
    var days = scheduledBreak.days,
      startTime = scheduledBreak.startTime,
      endTime = scheduledBreak.endTime,
      timezone = scheduledBreak.timezone,
      rest = (0, _objectWithoutProperties2["default"])(scheduledBreak, _excluded7);
    function transformTime(timestamp) {
      return _momentTimezone["default"].unix(timestamp).format('HHmm');
    }
    return _objectSpread(_objectSpread({}, rest), {}, {
      endTime: transformTime(endTime),
      startTime: transformTime(startTime),
      timezone: timezone || _momentTimezone["default"].tz.guess(),
      days: days.map(function (checked, i) {
        return checked ? i + 1 : null;
      }).filter(Boolean)
    });
  },
  fromAPI: function fromAPI(scheduledBreak) {
    var days = scheduledBreak.days,
      startTime = scheduledBreak.startTime,
      endTime = scheduledBreak.endTime,
      rest = (0, _objectWithoutProperties2["default"])(scheduledBreak, _excluded8);
    function transformTime(input) {
      return (0, _momentTimezone["default"])(input, 'HHmm').unix();
    }
    return _objectSpread(_objectSpread({}, rest), {}, {
      endTime: transformTime(endTime),
      startTime: transformTime(startTime),
      days: new Array(7).fill(false).map(function (_, i) {
        return days.includes(i + 1);
      })
    });
  }
};
var withCaptcha = exports.withCaptcha = function withCaptcha(captcha) {
  return (0, _requests.withHeaders)({
    'x-Auth-Captcha': captcha
  });
};
var withPhoneNumberToken = exports.withPhoneNumberToken = function withPhoneNumberToken(token) {
  return (0, _requests.withHeaders)({
    'X-Phone-Number-Token': token
  });
};
var withEmailCodeToken = exports.withEmailCodeToken = function withEmailCodeToken(token) {
  return (0, _requests.withHeaders)({
    'X-Email-Code-Token': token
  });
};
//# sourceMappingURL=utils.js.map